import { getAllSpecializationAreasReq } from "../../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../../components/ui/InputField1"
import FileInput from "../../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"
import { validateNumber } from "../../../../../utils/velidations"


function YogaTeacher({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b35"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          label="Yoga Teacher Training Certifications *"
          errText="Please upload yoga teacher training certifications"
          placeholderText="Upload Yoga Teacher Training Certifications"
          defaultValue={specialist?.profile?.specializationCertificate || []}
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Yoga Styles Offered *"
          errText="Please select yoga styles offered"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="experience"
          onChangeFun={validateNumber}
          label="Teaching Experience *"
          placeholder="Enter Teaching Experience"
          errText="Please enter teaching experience"
          defaultValue={specialist?.profile?.experience || ""}
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="ageGroupPreference"
          label="Client Age Group Preference *"
          placeholder="Enter Client Age Group Preference"
          errText="Please enter client age group preference"
          defaultValue={specialist?.profile?.ageGroupPreference || ""}
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Upload Additional certificates"
          placeholderText="Upload Section for Certifications"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Register as a Yoga Teacher on Innerpal. Your practice in teaching yoga enriches lives. Share your qualifications and teaching style to connect with our wellness community
      </Typography>
    </Fragment>
  )
}

export default YogaTeacher